import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, List, ListItem, Popover, Slide, TextField, Typography, IconButton, Stack } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPageMessage, setProcessing, setTableAttributes } from "../../store/ApplicationStore";
import { apiEndpoints, appConfigs } from "../../constants/ApplicationConstants";
import { getRequest, postRequest } from "../../utils/ApiUtil";
import { editSopDocumentInStore, storeSopDocuments } from "../../store/AdminMasterSOPStore";
import { SOPListSerializer, SOPSerializer } from "../../serializers/SOPSerializer";
import { DataGrid } from "@mui/x-data-grid";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import { Delete, DocumentScanner, Visibility, Edit, MoreVert, Refresh, Repeat, Close } from "@mui/icons-material";
import { useHandleError } from "../others/ErrorScreen";
import DocViewer from '../../components/DocViewer';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function MasterSOPsScreen(){
    const { sops } = useSelector(state => state.adminmastersops);
    const { tableAttributes } = useSelector(state => state.app);
    const handleError=useHandleError()
    const [showEditPop, setShowEditPop]= useState(false)
    const [ docName, setDocName ]= useState("")
    const [showDeletePop, setShowDeletePop]= useState(false)
    const [selectedRecord, setSelectedRecord]= useState(null) 
    const [showRepeatPop, setShowRepeatPop]= useState(false)
    const [ sopCharCount, setSopCharCount ]= useState(appConfigs.masterSOPCharcount);

    const [ showDocumentViewer, setShowDocumentViewer ] = useState(false);
    const [ documentObject, setDocumentObject ] = useState(null);

    const dispatch= useDispatch();

    const fetchMasterSops = useCallback(async (params)=> {
        try{
            dispatch(setProcessing(true));
            const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.masterSopsList, { ...tableAttributes, ...params, new: false });
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                dispatch(setTableAttributes({ ...tableAttributes, ...params}))
                dispatch(storeSopDocuments(SOPListSerializer(response.data)));
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }catch(err){
            handleError(err)
        }    
    }, [dispatch, tableAttributes,handleError]);

    useEffect(()=>{
        if(!sops){
            dispatch(setTableAttributes(appConfigs.tableAttributes));
            fetchMasterSops({column: "created_on"});
        }
    },[dispatch, fetchMasterSops, sops]);

    function handleEditToggle(record){
        if(showEditPop){
            setShowEditPop(false); setDocName(""); setSelectedRecord(null); setSopCharCount(appConfigs.masterSOPCharcount);
        }else{
            setShowEditPop(true); setSelectedRecord(record); record && setDocName(record.sop_name);
        }
    }
    async function handleEditSubmit(){
        try{
            dispatch(setProcessing(true));
            if(docName.trim()!==""){
                if(docName !== selectedRecord.sop_name){
                    const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.masterSopEdit, {
                        "id": selectedRecord.id,
                        "sop_name": docName.trim()
                    });
                    if(response.isError){
                        setShowEditPop(false); setDocName(""); setSelectedRecord(null);
                        dispatch(setPageMessage({message: response.message, type: "error"}));
                        dispatch(setProcessing(false));
                    }else{                       
                        dispatch(editSopDocumentInStore(SOPSerializer(response.data)));
                        setShowEditPop(false); setDocName(""); setSelectedRecord(null); setSopCharCount(appConfigs.masterSOPCharcount);
                        dispatch(setPageMessage({message: response.message, type: "success"}));
                        dispatch(setProcessing(false))
                    }
                }else{
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: "No modification in the Master SOP name.", type: "error"}));
                }
            }else{
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: "Enter a valid name.", type: "error"}));
            }
        }catch(err){
            handleError(err)
        }    
    }
    function handleDeleteToggle(record){
        if(showDeletePop){
            setShowDeletePop(false); setSelectedRecord(null);
        }else{
            setShowDeletePop(true); setSelectedRecord(record);
        }
    }
    async function handleDeleteSubmit(){
        try{
            dispatch(setProcessing(true));
            const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.deleteMasterSop+"/"+selectedRecord.id);
            if(response.isError){
                setShowDeletePop(false); setSelectedRecord(null);
                dispatch(setPageMessage({message: response.message, type: "error"}));
                dispatch(setProcessing(false));
            }else{
                dispatch(setTableAttributes(appConfigs.tableAttributes));
                fetchMasterSops({column: "created_on"});
                setShowDeletePop(false); setSelectedRecord(null);
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }catch(err){
            handleError(err)
        }     
    }
    function handleRepeatToggle(record){
        if(showRepeatPop){
            setShowRepeatPop(false); setSelectedRecord(null);
        }else{
            setShowRepeatPop(true); setSelectedRecord(record); 
        }
    }
    async function handleRepeatSubmit(){
        try{
            dispatch(setProcessing(true));
            const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.repeatMasterSop+"/"+selectedRecord.id);
            if(response.isError){
                setShowRepeatPop(false); setSelectedRecord(null);
                dispatch(setPageMessage({message: response.message, type: "error"}));
                dispatch(setProcessing(false));
            }else{
                dispatch(editSopDocumentInStore(SOPSerializer(response.data)))
                setShowRepeatPop(false); setSelectedRecord(null);
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }catch(err){
            handleError(err)
        }   
    }
    async function handleRefreshSubmit(record){
        fetchMasterSops({column: "created_on"});
    }
    function formatDate(value){
        const date = new Date(value);
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);
        return formattedDate
    }

    const base64ToBlob = (base64String) => {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: 'application/pdf' });
    }

    async function handleFileExplorer(path, page, image){
        try{
            dispatch(setProcessing(true));
            const response= await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.loadDocument, {"file_path": path});
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                const blob = image ? response.data : base64ToBlob(response.data);
                const blobUrl = image ? response.data : URL.createObjectURL(blob);
                page ? setDocumentObject(blobUrl+"#page="+page) : setDocumentObject(blobUrl);
                image ? setShowDocumentViewer(false) : setShowDocumentViewer(true);
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }
        catch(err){
            handleError(err)
        }    
    }

    return(
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box>
                        <Box display='flex' >
                            <DocumentScanner sx={{marginRight: '1rem',marginTop:'0.3rem'}}/>
                            <Stack direction='row' alignItems='center'>
                            <Box>
                                <Typography variant='h5'>Generated Master SOPs</Typography>
                                <Typography sx={{opacity: '0.6'}} variant='subtitle2'>View the generated Master SOPs.</Typography>
                            </Box>
                            <Refresh onClick={()=>fetchMasterSops({column: "created_on"})} sx={{marginLeft: '1rem', opacity: 0.6, cursor:'pointer'}} />
                            </Stack>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    {sops && <DataGrid
                        sx={{
                            '& .MuiDataGrid-columnHeaders': {
                            '& .MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 'bold',
                            },
                            },
                        }}
                        slotProps={{
                            filterPanel: {
                                filterFormProps:{
                                    operatorInputProps:{
                                        sx:{
                                            display: 'none'
                                        }
                                    }
                                }
                            }
                        }}
                        disableRowSelectionOnClick
                        autoHeight
                        rows={sops.records}
                        columns={[
                            { field: 'sop_name', hideable: false,  headerName: 'Master SOP Name', width: 250},
                            { field: 'docs_used_file_name', headerName: 'Documents Used', filterable: false, disableColumnMenu: true, sortable: false, width: 400},
                            { field: 'master_sop_cost', headerName: 'Cost Incurred', filterable: false, disableColumnMenu: true, sortable: false, width: 150,  valueGetter: (value) => value?`$ ${value.toFixed(2)}`:"Not Available"},
                            { field: 'status', headerName: 'Status', filterable: false, disableColumnMenu: true, width: 150, renderCell: (params) => (
                                <Box mt={2}>
                                    {params.row.status === 1 && <Typography sx={{color:'orange'}}  color='white.main'>In Progress</Typography>}
                                    {params.row.status === 2 && <Typography sx={{color:'green'}}  color='white.main'>Success</Typography>}
                                    {params.row.status === 3 && <Typography sx={{color:'red'}}  color='white.main'>Failed</Typography>}
                                </Box>
                            )},
                            { field: 'created_on', headerName: 'Created On', filterable: false, disableColumnMenu: true, width: 250, valueGetter: (value) => formatDate(value) },
                            { field: 'customField', headerName: 'Actions', width: 150, filterable: false, disableColumnMenu: true, sortable:false, renderCell: (params) => (
                                <PopupState variant="popover">
                                    {(popupState) => (
                                    <>
                                        <MoreVert sx={{cursor: 'pointer', mt:1.5}} {...bindTrigger(popupState)} />
                                        <Popover {...bindPopover(popupState)} anchorOrigin={{ vertical: 'center', horizontal: 'right' }} >
                                            <List sx={{p: 2}}>
                                                {params.row.status === 2&&<ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=>{handleFileExplorer(params.row.doc_url, null, false); popupState.close();}}>
                                                    <Box display="flex" alignItems="center">
                                                        <Visibility  sx={{marginRight: '1rem'}} />
                                                        <Typography>View</Typography>
                                                    </Box>
                                                </ListItem>}
                                                {params.row.status === 2&&<ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=>{handleEditToggle(params.row); popupState.close()}}>
                                                    <Box display="flex" alignItems="center">
                                                        <Edit  sx={{marginRight: '1rem'}} />
                                                        <Typography>Edit</Typography>
                                                    </Box>
                                                </ListItem>}
                                                {(params.row.status === 2 || params.row.status === 3)&&<ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=>{handleDeleteToggle(params.row); popupState.close()}}>
                                                    <Box display="flex" alignItems="center">
                                                        <Delete  sx={{marginRight: '1rem'}} />
                                                        <Typography>Delete</Typography>
                                                    </Box>
                                                </ListItem>}
                                                {(params.row.status === 2 || params.row.status === 3)&&<ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=>{handleRepeatToggle(params.row); popupState.close()}}>
                                                    <Box display="flex" alignItems="center">
                                                        <Repeat  sx={{marginRight: '1rem'}} />
                                                        <Typography>Retry</Typography>
                                                    </Box>
                                                </ListItem>}
                                               { params.row.status === 1 && <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=>{handleRefreshSubmit(params.row);popupState.close()}}>
                                                    <Box display="flex" alignItems="center">
                                                        <Refresh  sx={{marginRight: '1rem'}} />
                                                        <Typography>Refresh</Typography>
                                                    </Box>
                                                </ListItem>
                                                }
                                            </List>
                                        </Popover>
                                    </>
                                    )}
                                </PopupState>  
                            )},

                        ]}
                        pagination
                        initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: sops.page_size,
                                page: sops.current_page,
                              },
                            }
                        }}
                        pageSizeOptions={appConfigs.tablePageOptions}
                        paginationMode='server'
                        sortingMode="server"
                        onSortModelChange={(param)=>fetchMasterSops(param[0]?{column:param[0].field, order: param[0].sort}:{column: "created_on"})}
                        rowCount={sops.total_elements}
                        onPageChange={(param)=>fetchMasterSops({column:param[0].field, order: param[0].sort})}
                        onPaginationModelChange={(param)=>fetchMasterSops({page: param.page+1, size:param.pageSize, column: "created_on"})}
                        filterMode="server"
                        onFilterModelChange={(param)=>fetchMasterSops(param.items[0]?{column:param.items[0].field, search: param.items[0].value}:{column: "created_on"})}
                    /> }
                </Grid>
            </Grid>
            <Dialog fullWidth open={showEditPop} TransitionComponent={Transition} keepMounted onClose={()=> handleEditToggle()}>
                <DialogTitle>Edit Master SOP Name</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <TextField fullWidth size="small" inputProps={{ maxLength: appConfigs.masterSOPCharcount }} label="SOP Name" value={docName} onChange={(e)=>{setDocName(e.target.value.trimStart()); setSopCharCount(appConfigs.masterSOPCharcount - e.target.value.trimStart().length)}}/>
                        <Typography>{sopCharCount !== appConfigs.masterSOPCharcount ? `${sopCharCount} characters remaining.` : `Maximum ${appConfigs.masterSOPCharcount} characters are allowed.`}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=> handleEditToggle(false)}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=> handleEditSubmit()}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showDeletePop} TransitionComponent={Transition} keepMounted onClose={()=> handleDeleteToggle()}>
                <DialogTitle>Delete Master SOP</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography>Are you sure you want to delete this Master SOP?</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=> handleDeleteToggle(false)}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=> handleDeleteSubmit()}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showRepeatPop} TransitionComponent={Transition} keepMounted onClose={()=> handleRepeatToggle()}>
                <DialogTitle>Repeat Master SOP</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography>{appConfigs.remasterSOPDisclaimer}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=> handleRepeatToggle()}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=> handleRepeatSubmit()}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth fullScreen open={showDocumentViewer} TransitionComponent={Transition} keepMounted onClick={()=>{setShowDocumentViewer(false); setDocumentObject(null);}}>
                <DialogTitle>
                    <IconButton
                    onClick={()=>{setShowDocumentViewer(false); setDocumentObject(null);}}
                    sx={{ color: "#000000", float: 'right'}} >
                    <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DocViewer link={documentObject} downloadable={appConfigs.allowDocDownload} />
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>{setShowDocumentViewer(false); setDocumentObject(null);}}>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}